exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-app{background-color:#fee07c;border-radius:.5rem;height:38rem;margin:0 auto;padding:2rem;width:33rem}.my-app__title{font-family:fantasy;font-size:3rem;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/components/mainApp.scss
// module id = 228
// module chunks = 0